import { render, staticRenderFns } from "./BankCredsHelpPopup.vue?vue&type=template&id=2ca585ac&scoped=true&"
import script from "./BankCredsHelpPopup.vue?vue&type=script&lang=js&"
export * from "./BankCredsHelpPopup.vue?vue&type=script&lang=js&"
import style0 from "./BankCredsHelpPopup.vue?vue&type=style&index=0&id=2ca585ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca585ac",
  null
  
)

export default component.exports